import CustomActionComponents from "../Components/CustomActionComponents/CustomActionComponents";

export default function CustomAction() {
  return <CustomActionComponents />;
}
